import axios from 'axios';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TwilioError } from 'twilio-video';
import { ActionAuth, AxiosAuth } from '..';
import { AppConstants, PlatformApi } from '../../configs';
import { useWebSocket } from '../../pages/hooks';
import { logger } from '../../utils';
import { useAppSelector, VRIAppStateType } from '../Redux';
// import { AssetsAudio } from '../../assets';


export const SocketContext = React.createContext<{
  socketConnection: WebSocket | null;
  loadTwilioToken: () => void;
  token: string | null;
}>({ socketConnection: null, loadTwilioToken: () => { }, token: null });

export function SocketContextProvider(
  props: React.PropsWithChildren<{}>
): JSX.Element {
  const dispatch = useDispatch();
  const { webToken, isLoggedIn } = useAppSelector((state: VRIAppStateType) => ({
    profileId: state.auth.profile?.id,
    isLoggedIn: state.auth.isLoggedIn,
    webToken: state.auth.VRItoken,
  }));
  // const webTokenRef = useRef(webToken);
  const { webSocketConnection: socketConnection } = useWebSocket();
  const [token, setToken] = useState<string | null>(webToken || null);

  const loadTwilioToken = useCallback(() => {
    logger({ message: 'Getting WebToken' });
    return AxiosAuth.get(PlatformApi.Authentication.Token())
      .then((response) => {
        if (!!response.data && response.status === AppConstants.Api.StatusOK) {
          const token = response.data.token;
          // if (webTokenRef.current) {
          // logger({ message: 'Updating WebToken' });
          setToken(token);
          // } else {
          //   logger({ message: 'Initiating WebToken' });
          //   setDevice(new Device(token, {
          //     // enableRingingState: true,
          //     sounds: {
          //       incoming: 'https://audiocalltest.s3.us-east-2.amazonaws.com/video_reciever_tone.mp3'
          //     }
          //   }));

          // }
          dispatch(ActionAuth.SetVRItoken(token));
          // webTokenRef.current = token;
        }
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          logger({
            message: 'Error: Fetching WebToken failed: ',
            data: error.response,
          });
          throw error;
        }
      });
  }, [dispatch]);

  const socketConnectionMemo = useMemo(
    () => ({ socketConnection, loadTwilioToken, token }),
    [socketConnection, loadTwilioToken, token]
  );

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    loadTwilioToken();
  }, [isLoggedIn, loadTwilioToken]);

  // useEffect(() => {
  //   const handleDeviceOffline = (error: TwilioError) => {
  //     if (error.code === 31205) {
  //       loadTwilioToken();
  //     }
  //   };
  //   device?.on('error', handleDeviceOffline);

  //   return () => {
  //     device?.off('error', handleDeviceOffline);
  //   };
  // }, [loadTwilioToken]);

  return (
    <SocketContext.Provider value={socketConnectionMemo}>
      {props.children}
    </SocketContext.Provider>
  );
}
